import { MailMessageFullView } from "../MailMessageFullView/index.js";
import { MailMessageFullViewFromId } from "../MailMessageFullView/MailMessageFullViewFromId.js";
import { useState } from "react";
import { Button } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { pluralize } from "@therms/web-js";
// src/modules/Mail/components/MailMessageThread/index.tsx
function MailMessageThread({ afterMessagesCount = 0, beforeMessagesCount = 0, message, threadMessageIds }) {
	const [showingThread, setShowingThread] = useState(false);
	return /* @__PURE__ */ jsxs("div", {
		className: "",
		children: [
			!!beforeMessagesCount && (showingThread ? threadMessageIds?.slice(0, beforeMessagesCount).map((threadMessageId) => /* @__PURE__ */ jsx("div", {
				className: "p-base",
				children: /* @__PURE__ */ jsx(MailMessageFullViewFromId, {
					hideSubject: true,
					mailMessageId: threadMessageId
				})
			}, threadMessageId)) : /* @__PURE__ */ jsx("div", {
				className: "py-base",
				children: /* @__PURE__ */ jsxs(Button, {
					onClick: () => setShowingThread(true),
					fullWidth: true,
					size: "sm",
					subtle: true,
					variant: "main",
					children: [
						"--- ",
						beforeMessagesCount,
						" newer",
						" ",
						pluralize("message", beforeMessagesCount),
						" ---"
					]
				})
			})),
			/* @__PURE__ */ jsx("div", {
				className: "rounded bg-surface-strong p-base",
				children: /* @__PURE__ */ jsx(MailMessageFullView, {
					sender: message.sender,
					sentAt: message.sentAt,
					receiverUserAndGroups: message.receiverUserAndGroups,
					ccUserAndGroups: message.ccUserAndGroups,
					fileUrls: message.fileUrls,
					body: message.bodyHtml || message.body
				})
			}),
			!!afterMessagesCount && (showingThread ? threadMessageIds?.slice(beforeMessagesCount + 1).map((threadMessageId) => /* @__PURE__ */ jsx("div", {
				className: "p-base",
				children: /* @__PURE__ */ jsx(MailMessageFullViewFromId, {
					hideSubject: true,
					mailMessageId: threadMessageId
				})
			}, threadMessageId)) : /* @__PURE__ */ jsx("div", {
				className: "py-base",
				children: /* @__PURE__ */ jsxs(Button, {
					onClick: () => setShowingThread(true),
					fullWidth: true,
					size: "sm",
					subtle: true,
					variant: "main",
					children: [
						"--- ",
						afterMessagesCount,
						" older",
						" ",
						pluralize("message", afterMessagesCount),
						" ---"
					]
				})
			}))
		]
	});
}
export { MailMessageThread };

//# sourceMappingURL=index.js.map